import React from "react";

const CardCertificadosAtivos: React.FC<any> = (props) => {
  return (
    <div className="card" style={{ height: "433px" }}>
      <div className="card-body align-self-center">
        <h5 className="card-title fw-bold text-center mb-5 fs-22px">
          Certificados Ativos
        </h5>
        <div className="d-flex flex-column align-items-center">
          <h6 className="fs-5">Você possui</h6>
          <span
            className="fw-bold text-primary"
            style={{ fontSize: "100px", fontFamily: "Roboto" }}
          >
            24
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardCertificadosAtivos;
